import styles from "./LoadingSpinner.module.css";

const LoadingSpinner = ({ text = "Loading..." }) => {
  return (
    <div className={styles.loaderBox}>
      <div className={styles.spinner} />
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default LoadingSpinner;
